
export const isServiceCategoryURL = pathname =>
  /^.*\/[0-9]{5,6}\/.+/.test(pathname)


export const getStoreBaseURL = pathname => {
  const URLmatches = pathname.match(/^.*\/[0-9]{5,6}/)
  return URLmatches && URLmatches.length ? URLmatches[0] : ''
}
